var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 19,
  width: 8.5,
  height: 7,
  rx: 0.9,
  fill: "#b9c2c9"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4.8,
  y: 20.7,
  width: 3.6,
  height: 3.6,
  fill: "#71808a"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 15.5,
  width: 18.5,
  height: 14,
  rx: 2.5,
  fill: "#c8503f"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.6,
  cy: 18.7,
  r: 1.15,
  fill: "#58c47a"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.7,
  cy: 18.7,
  r: 1.15,
  fill: "#f2c14e"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m14.4 24.5h13.7",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m17.5 24.5v-2.4",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 16.3,
  y: 19.9,
  width: 2.4,
  height: 2.4,
  rx: 0.5,
  fill: "#ffffff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m23 24.5v2.2",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 21.8,
  y: 26.1,
  width: 2.4,
  height: 2.4,
  rx: 0.5,
  fill: "#ffffff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 16.8,
  width: 2.6,
  height: 11.4,
  rx: 0.8,
  fill: "#8f9ba3"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 32.6,
  y: 18.6,
  width: 8,
  height: 7.8,
  rx: 2.7,
  fill: "#b9c2c9"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.2,
  cy: 21.3,
  r: 0.5,
  fill: "#5c676e"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 21.3,
  r: 0.5,
  fill: "#5c676e"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.8,
  cy: 21.3,
  r: 0.5,
  fill: "#5c676e"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.1,
  cy: 21.3,
  r: 0.5,
  fill: "#5c676e"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.4,
  cy: 21.3,
  r: 0.5,
  fill: "#5c676e"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.85,
  cy: 23.8,
  r: 0.5,
  fill: "#5c676e"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.15,
  cy: 23.8,
  r: 0.5,
  fill: "#5c676e"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.45,
  cy: 23.8,
  r: 0.5,
  fill: "#5c676e"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.75,
  cy: 23.8,
  r: 0.5,
  fill: "#5c676e"
});

function SvgCanUsbAdapter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanUsbAdapter);
export default __webpack_public_path__ + "static/media/can-usb-adapter.bd4f842fd18f8cea5337974fbd2d5184.svg";
export { ForwardRef as ReactComponent };